import { CIMSPage } from 'shared'
import { useUserDeleted } from 'hooks/useUserDeleted'
import ProjectLink from 'components/ProjectLink'
import { Tooltip, Typography } from 'antd'
import { RenderedUser } from './types'

export const SingleUser: React.VFC<RenderedUser> = (user) => {
  const isDeleted = useUserDeleted()
  if (isDeleted(user))
    return (
      <Tooltip title={user.displayName ? `${user.mail} (Inactive)` : undefined}>
        <Typography.Text delete={true}>
          {user.displayName ?? user.mail}
        </Typography.Text>
      </Tooltip>
    )
  return (
    <ProjectLink item={CIMSPage.Users} deep={{ recordId: user.id }}>
      <Tooltip title={user.displayName ? user.mail : undefined}>
        {user.displayName ?? user.mail}
      </Tooltip>
    </ProjectLink>
  )
}
